import { buildUrlFromLocation } from "@/utils/httpUtils";
import http from "@/services/http";

export default {
    async getAll() {
        return await http.get(buildUrlFromLocation(`/admin/sections`, { campaignId: null }));
    }
};



// WEBPACK FOOTER //
// ./src/services/section.js